
export const SERVICE_ROUTES = [
  {
    path: "serviceTypeForm",
    name: "serviceTypeForm",
    component: () =>
        import(/* webpackChunkName: "services" */ "@/modules/services/components/forms/ServiceTypeForm")
  },

  {
    path: "serviceDetailForm",
    name: "serviceDetailForm",
    component: () =>
        import(/* webpackChunkName: "services" */ "@/modules/services/components/forms/ServiceDetailForm")
  },
  {
    path: "serviceOverview",
    name: "serviceOverview",
    component: () =>
        import(/* webpackChunkName: "services" */ "@/modules/services/layouts/ServiceOverview")
  }
];
